import { isString } from 'lodash';
import moment, { unitOfTime } from 'moment';

import type { ActiveButton, RelativeTimeOption } from './types';

export type Value = React.Key | undefined; /* string | number | undefined */

export const RelativeTimeOptions: RelativeTimeOption[] = [
  { value: 'h', label: 'Hours ago' },
  { value: 'd', label: 'Days ago' },
  { value: 'w', label: 'Weeks ago' },
  { value: 'M', label: 'Months ago' },
  { value: 'y', label: 'Years ago' },
  { value: 'h+', label: 'Hours from now' },
  { value: 'd+', label: 'Days from now' },
  { value: 'w+', label: 'Weeks from now' },
  { value: 'M+', label: 'Months from now' },
  { value: 'y+', label: 'Years from now' },
];

export const isRelativeTime = (value: string): boolean => {
  const relativeTimePattern = /^\d+\s*[hdwMy]\+?$/;
  return relativeTimePattern.test(value);
};

export const convertRelativeToAbsolute = (
  value?: Value,
  activeDate?: ActiveButton,
): number => {
  if (value && isString(value)) {
    let date = moment();
    const [count, unit] = value.split(' ');
    if (count && unit) {
      if (value.endsWith('+')) {
        date = date.add(+count, unit[0] as unitOfTime.DurationConstructor);
      } else {
        date = date.subtract(+count, unit[0] as unitOfTime.DurationConstructor);
      }
      // if relative time is less than a day then don't convert to start/end of day
      if ('h' !== unit[0]) {
        if (activeDate === 'end') {
          date = date.endOf('D');
        } else {
          date = date.startOf('D');
        }
      }
    }
    return date.toDate().getTime();
  }
  return Date.now();
};

export const convertAbsoluteToRelative = (value?: Value): string => {
  if (value) {
    const str = moment(value)
      .fromNow()
      .replace('days', 'd')
      .replace('day', 'd')
      .replace('weeks', 'w')
      .replace('week', 'w')
      .replace('months', 'M')
      .replace('month', 'M')
      .replace('years', 'y')
      .replace('year', 'y');

    if (str.includes('hour') || str.includes('min') || str.includes('sec')) {
      return '0 d';
    }
    if (str.startsWith('in')) {
      return str.replace('in', '').trim() + '+';
    }
    if (str.endsWith('ago')) {
      return str.replace('ago', '').trim();
    }
  }
  return '0 d';
};
